/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect, useRef } from "react";
import PendingPrsList from "./PendingPrsList/PendingPrsList";
import Heading from "../../components/Heading";

const PendingPRSMapping = () => {
  return (
    <div className="p-1">
      <Heading title="Pending PRS Mapping" />
      <div className="global-card-tab-container">
        <PendingPrsList />
      </div>
    </div>
  );
};

export default PendingPRSMapping;
